import React from "react";

import styled from "styled-components/macro";

import { useIsBillingAdmin } from "Flocknote/stateHooks";

import AdminPageWrapper from "CrossFeatureComponents/AdminPageWrapper";
import ActivateFNPButton from "Giving/Marketing/ActivateFNPButton";
import { navSectionKeys } from "NavBar/navBarStore";

import FnrButton3 from "UI/FnrButton3";
import FnrIcon from "UI/FnrIcon";
import FnrTypography from "UI/FnrTypography";
import { colors, navColors } from "UI/colors";

export default function NoCampaigns() {
  const isBillingAdmin = useIsBillingAdmin();
  const showUpgradeButton = isBillingAdmin;

  return (
    <AdminPageWrapper
      showGridBackground
      navSectionKey={navSectionKeys.giving}
    >
      <Wrapper>
          <Content>
            <FeaturePill>Flocknote Complete</FeaturePill>
            <FnrTypography type="header" fontSize="2rem">
              Campaigns & Pledge Tracking
            </FnrTypography>
            <FnrTypography>
              With our Campaign and Pledge Tracking feature included as part of
              Flocknote Complete, you can easily create a campaign for one of
              your funds and start tracking pledges in just minutes! Flocknote
              Complete is an additional $75/month. No contracts, cancel anytime.
            </FnrTypography>

            <InfoRow>
              <IconWrapper>
                <FnrIcon icon="fa-check far" center />
              </IconWrapper>
              <Stack>
                <FnrTypography fontSize="lg" fontWeight={600}>
                  Reduce your paper pledge tracking.
                </FnrTypography>
                <FnrTypography>
                  Members can effortlessly make pledges online. Pledges will
                  automatically sync to their profiles in Flocknote.
                </FnrTypography>
              </Stack>
            </InfoRow>
            <InfoRow>
              <IconWrapper>
                <FnrIcon icon="fa-check far" centered />
              </IconWrapper>
              <Stack>
                <FnrTypography fontSize="lg" fontWeight={600}>
                  Up-to-date Tracking
                </FnrTypography>

                <FnrTypography>
                  Easily apply member donations towards their campaign pledge
                  when manually tracking gifts in Flocknote.
                </FnrTypography>
              </Stack>
            </InfoRow>
            <InfoRow>
              <IconWrapper>
                <FnrIcon icon="fa-check far" centered />
              </IconWrapper>
              <Stack>
                <FnrTypography fontSize="lg" fontWeight={600}>
                  Bonus power-up!
                </FnrTypography>

                <FnrTypography>
                  If Online Giving is enabled in Flocknote, donors can quickly
                  make pledge payments online anytime, or create a recurring
                  gift to meet their pledge.
                </FnrTypography>
              </Stack>
            </InfoRow>

            <CTAs>
              <CTAStack>
                {showUpgradeButton && <ActivateFNP />}

                {!showUpgradeButton && (
                  <a
                    href="https://flocknote.com/blog/dollars-for-diesel-one-churchs-groundbreaking-fundraiser/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FnrButton3 size="large" color="blue">
                      Read a Fundraising Success Story
                    </FnrButton3>
                  </a>
                )}

                <LearnMoreLink
                  href="https://flocknote.com/flocknote-complete"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FnrIcon
                    icon="fa-info-circle fas"
                    style={{ display: "inline", marginRight: ".25rem" }}
                  />{" "}
                  Learn&nbsp;More
                </LearnMoreLink>
              </CTAStack>
            </CTAs>
          </Content>
        </Wrapper>
    </AdminPageWrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 40px;
  box-sizing: border-box;

  container-type: inline-size;
  container-name: CampaignUpgrade;
`;

const Content = styled.div`
  display: grid;
  gap: 1.75rem;
  z-index: 1;
`;

const FeaturePill = styled.div`
  display: inline-block;
  background-color: ${`${navColors.database}cc`};
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  width: fit-content;
  margin-block-end: -0.75rem;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const IconWrapper = styled.div`
  width: 30px;
  font-size: 2.5rem;
  text-align: center;
  color: ${`${navColors.database}cc`};

  @container CampaignUpgrade (max-width: 375px) {
    display: none;
  }
`;

const CTAs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 0.25rem;
`;

const ActivateFNP = styled(ActivateFNPButton)`
  margin: 1rem 1rem 1rem 0;
`;

const LearnMoreLink = styled.a`
  display: inline-block;
  color: ${colors.fnGray500};
  text-decoration: none;
  text-align: center;
  padding-block: 1rem;
`;

const Stack = styled.div`
  display: grid;
  gap: 0.5rem;
`;

const CTAStack = styled.div`
  display: grid;
  justify-content: center;

  a:hover {
    text-decoration: none !important;
  }
`;
